import { AirportDetails, BookingLeg, getArrivalLocation, getDepartureLocation, Location, locationMatch } from 'acscp/store';
import { Leg } from 'acscp/api/models/leg';
import log from 'loglevel';

function getAirportForLocation(airports: AirportDetails[], location: Location): AirportDetails | null {

    const matchingAirports = airports.filter(airport => locationMatch(airport, location));

    if (matchingAirports.length === 1) {
        return matchingAirports[0];
    } else {
        log.error(
            `Found unexpected amount (${matchingAirports.length}) of matching airports ` +
            `for location "${location.location}" (id: ${location.airportId}) ` +
            `among ${airports.length} airports`);
        return null;
    }
}

export const getDepartureAirportFromLeg =
    (airports: AirportDetails[], flight: Leg) => getAirportForLocation(airports, getDepartureLocation(flight));

export const getArrivalAirportFromLeg =
    (airports: AirportDetails[], flight: Leg) => getAirportForLocation(airports, getArrivalLocation(flight));
